export enum RecordChangeSourceType {
	PORTAL = 'portal',
	LOCAL_VIEWER = 'local-viewer',
}
